<template>
  <div class="chart flex-column flex-justify-start flex-align-start" :class="[{'card-gap': gap}]">
    <div class="chart-head flex-row flex-justify-start flex-align-start">(空压)流量</div>
    <div class="chart-contain flex-row flex-justify-center flex-align-start">
      <div id="flowref" class="chart-area"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'FlowChart',
  props: {
    gap: {
      type: Boolean,
      default: true
    },
    flow: {
      type: Object,
      default: () => ({
        thisflow: [],
        lastflow: []
      })
    }
  },
  data() {
    return {
      flowChart: null
    }
  },
  watch: {
    flow: {
      handler() {
        this.$nextTick(() => {
          this.initChart()
        })
      },
      deep: true
    },
  },
  beforeDestroy() {
    if(this.flowChart != null) {
      this.flowChart.dispose()
      this.flowChart = null
    }
  },
  methods: {
    initChart() {
      var chartDom = document.getElementById('flowref')
      if(!chartDom) {
        return
      }
      if (!this.flowChart) {
        this.flowChart = echarts.init(chartDom);
      }
      var option = {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'text-align: left;',
          axisPointer: {
            type: 'none'
          }
        },
        legend: {
          data: ['今年流量', '去年流量']
        },
        xAxis: [
          {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '流量 / m³',
            // min: 0,
            // max: 1500000,
            // interval: 300000,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '今年流量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' m³';
              }
            },
            itemStyle: {
              color: '#75b1ff'
            },
            data: this.flow.thisflow
          },
          {
            name: '去年流量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + ' m³';
              }
            },
            itemStyle: {
              color: '#fedd69'
            },
            data: this.flow.lastflow
          }
        ]
      }
      this.flowChart.setOption(option)
    }
  }
}
</script>

<style scoped>
.chart {
  width: 49.5%;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}
.card-gap {
  margin-right: 1%;
}
.chart-head {
  font-family: 'Arial';
  font-size: 18px;
  margin-left: 20px;
  margin-top: 10px;
}
.chart-area {
  min-width: 800px;
  min-height: 400px;
}
.chart-contain {
  width: 100%;
  overflow: hidden;
}
</style>
